export default __webpack_public_path__ + "static/media/selectIcon.07bd8799.svg";